import { useBulkImportStore } from '../hooks/useBulkImportStore'

import { type CardDraftBulkImport } from './bulk-import.store.types'

import { randomUUID } from '@/utils/random-uuid'
import { checkTypeCardActivity } from '@/utils/checkTypeCard'

const addBlankCardDraftEntry = () => {
  useBulkImportStore.setState(state => {
    const cardsDraft = state.cardsDraft

    const newCard: CardDraftBulkImport = {
      type: 'text',
      prompt: '',
      native_text: '',
    }

    const randomId = randomUUID()

    const newMap = new Map([[randomId, newCard], ...cardsDraft])

    return {
      ...state,
      cardsDraft: newMap,
    }
  })
}

const convertStringsToCardDrafts = (strings: string[]) => {
  useBulkImportStore.setState(state => {
    const newMapDraftCards = new Map()
    const cardType = state.cardType

    const { isRepeat } = checkTypeCardActivity(cardType === 'idle' ? undefined : cardType)

    if (isRepeat) {
      for (let i = 0; i < strings.length; i += 2) {
        const randomId = randomUUID()

        const prompt = strings[i] ?? ''
        const native_text = strings[i + 1] ?? ''

        if (prompt.length === 0) continue

        newMapDraftCards.set(randomId, {
          id: randomId,
          type: 'text',
          prompt,
          native_text,
        })
      }
    } else {
      for (const value of strings) {
        const randomId = randomUUID()

        if (value.length === 0) continue

        newMapDraftCards.set(randomId, {
          id: randomId,
          type: 'text',
          prompt: value,
          native_text: '',
        })
      }
    }

    const currentDraftCards = state.cardsDraft

    const newDraftCards = new Map([...newMapDraftCards, ...currentDraftCards])

    return {
      ...state,
      cardsDraft: newDraftCards,
    }
  })
}

const updateCardDraftEntry = (id: string, partial: Partial<CardDraftBulkImport>) => {
  useBulkImportStore.setState(state => {
    const cardsDraft = state.cardsDraft

    const newMap = new Map(cardsDraft)

    const card = newMap.get(id)

    if (!card) {
      return state
    }

    newMap.set(id, {
      ...card,
      ...partial,
    })

    return {
      ...state,
      cardsDraft: newMap,
    }
  })
}

const deleteCardDraftEntry = (id: string) => {
  useBulkImportStore.setState(state => {
    const cardsDraft = state.cardsDraft

    const newMap = new Map(cardsDraft)

    newMap.delete(id)

    return {
      ...state,
      cardsDraft: newMap,
    }
  })
}

export const functionsCardDraftEntry = {
  addBlankCardDraftEntry,
  convertStringsToCardDrafts,
  updateCardDraftEntry,
  deleteCardDraftEntry,
}
